<nz-table [nzData]="transactions" [nzPageSize]="5" nzSize="small">
	<thead>
		<tr>
			<th>Date</th>
			<th>Reference</th>
			<th>Description</th>
			<th nzAlign="right">Amount</th>
			<th>Status</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of transactions">
			<td>{{ row.date }}</td>
			<td>{{ row.reference }}</td>
			<td>{{ row.description }}</td>
			<td nzAlign="right">{{ row.amount | currency }}</td>
			<td>
				<nz-tag
					[nzColor]="row.status === 'Completed' ? 'success' : row.status === 'Pending' ? 'warning' : 'error'">
					{{ row.status }}
				</nz-tag>
			</td>
		</tr>
	</tbody>
</nz-table>
